'use client';

import React from "react";
import { cn } from "@/lib/utils";

interface ProgressBarProps {
  currentStep: number; // 1-based index
  totalSteps?: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps = 3 }) => {
  return (
    <div className="w-full max-w-5xl mx-auto flex items-center justify-between px-4 mt-8">
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1;
        const isCompleted = currentStep > step;
        const isActive = currentStep === step;

        return (
          <div key={step} className="flex items-center w-full last:w-auto">
            {/* Step circle */}
            <div
              className={cn(
                "w-6 h-6 rounded-full flex items-center justify-center border-2 border-gray-600 transition-all z-10",
                isCompleted
                  ? "bg-blue-500 border-blue-500"
                  : isActive
                  ? "border-blue-500 bg-background"
                  : "border-gray-600 bg-background"
              )}
            >
              {isCompleted ? (
                <svg
                  className="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              ) : isActive ? (
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500" />
              ) : null}
            </div>

            {/* Connecting line */}
            {step < totalSteps && (
              <div
                className={cn(
                  "flex-1 h-0.5 transition-all",
                  isCompleted
                    ? "bg-blue-500"
                    : "bg-gray-600"
                )}
              ></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
